import { IArea } from "@types";
import { BaseAPI } from "@utils";

class AreaApi extends BaseAPI<IArea> {}

export const areaApi = new AreaApi("/api/v1/area");
